import { render, staticRenderFns } from "./normal-preview-item.vue?vue&type=template&id=61a5c02e&scoped=true"
import script from "./normal-preview-item.vue?vue&type=script&lang=js"
export * from "./normal-preview-item.vue?vue&type=script&lang=js"
import style0 from "./normal-preview-item.vue?vue&type=style&index=0&id=61a5c02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5c02e",
  null
  
)

export default component.exports